import cloneDeep from 'lodash.clonedeep';
import merge from 'lodash.merge';

import { type QuestionType } from '@core/blocks/edu-flow/components/Page/types';
import { type Flags } from '@core/context/FeatureFlagsContext';
import generateAssetQuestion from '@core/editableAssets/generateAssetQuestion';
import questionBank from '@core/schemas/question_bank.json';

type TestResults = Record<string, any>;

// Gets a question from the question bank by id
const getQuestionById = (
  questionId: string,
  flags: Flags,
  noPii?: boolean,
  testResults?: TestResults
): QuestionType => {
  let question: QuestionType = cloneDeep(questionBank[questionId as keyof typeof questionBank] as QuestionType);

  if (question?.extends) {
    question = merge(getQuestionById(question.extends, flags, noPii, testResults), question);
    delete question.extends;
    question.fields =
      (questionBank[questionId as keyof typeof questionBank] as unknown as QuestionType).fields ?? question.fields;
  }
  if (question?.monarchEditableAssetFlag && flags) {
    question = generateAssetQuestion(question, flags, testResults);
  }

  return question;
};

export default getQuestionById;
